import { render, staticRenderFns } from "./Style2.vue?vue&type=template&id=9c524460&scoped=true&lang=pug&"
import script from "./Style2.vue?vue&type=script&lang=js&"
export * from "./Style2.vue?vue&type=script&lang=js&"
import style0 from "./Style2.scss?vue&type=style&index=0&id=9c524460&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c524460",
  null
  
)

export default component.exports